import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { useState } from "react";
import { getSaleList } from "@/api/sale/getSaleList";
import { SaleDetailModal } from "./SaleDetailModal";

export function SaleList() {
  const query = getSaleList.useQuery();
  const [selectedSaleId, setSelectedSaleId] = useState<string | null>(null);

  if (query.isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (query.isError) {
    return (
      <Alert severity="error">
        Failed to load sales: {JSON.stringify(query.error)}
      </Alert>
    );
  }

  const sales = query.data ?? [];

  return (
    <>
      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: "calc(100vh - 160px)" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Order #</TableCell>
              <TableCell>Customer</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Order Date</TableCell>
              <TableCell>Invoice #</TableCell>
              <TableCell align="right">Invoice Amount</TableCell>
              <TableCell>Fulfilment</TableCell>
              <TableCell>Shipping</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sales.map((sale) => (
              <TableRow
                key={sale.id}
                hover
                onClick={() => setSelectedSaleId(sale.id)}
                sx={{ cursor: "pointer" }}
              >
                <TableCell sx={{ fontFamily: "monospace" }}>{sale.id}</TableCell>
                <TableCell>{sale.orderNumber}</TableCell>
                <TableCell>{sale.customer}</TableCell>
                <TableCell>{sale.status}</TableCell>
                <TableCell>{sale.orderDate}</TableCell>
                <TableCell>{sale.invoiceNumber}</TableCell>
                <TableCell align="right">{sale.invoiceAmount}</TableCell>
                <TableCell>{sale.fulfilmentStatus}</TableCell>
                <TableCell>{sale.shippingStatus}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <SaleDetailModal
        saleId={selectedSaleId}
        onClose={() => setSelectedSaleId(null)}
      />
    </>
  );
}
